/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SuppliersAddComponent
 * Purpose		: This component allows to create new Suppliers record and save changes.
 * Dependency	: SuppliersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit,
	HostBinding, trigger, transition, animate,
	style, state } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { SuppliersData, SuppliersService } from './Suppliers.service';


@Component({
	selector: 'my-Suppliers-add',
	template: require('./SuppliersAdd.component.html'),
	providers: [SuppliersService
		
		],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class SuppliersAddComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objSuppliers: SuppliersData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

  constructor(
    private route: ActivatedRoute,
    private router: Router,
	private toastr: ToastsManager,
    private SuppliersService: SuppliersService

	) {
		this.objSuppliers = new SuppliersData();
	}

	ngOnInit() {
		this.objSuppliers = new SuppliersData();
		this.getLookups();
	}

	addSuppliers() {
		this.SuppliersService.addSuppliersData(this.objSuppliers)
			.subscribe(record => this.router.navigate(['/Suppliers']),
			error =>  this.errorMessage = 'There was an error while adding record. Error: ' + <any>error,
			() => { 
				this.toastr.success('Suppliers record added successfully...', 'Add Suppliers');
				console.log('Suppliers record added successfully...'); 
			}
		);
	}

	gotoSuppliers() {
		// let Id = this.objSuppliers ? this.objSuppliers.SupplierID : null;
		this.router.navigate(['/Suppliers']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Suppliers/SuppliersAdd.component.ts